import {
  Component,
  OnInit,
  Renderer2,
  HostListener,
  Inject,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef
} from "@angular/core";
import { Location } from "@angular/common";
import { DOCUMENT } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { MainFacade } from "./pages/main.facade";
import { Observable, Subject } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, AfterViewInit {
  showSide:boolean = false;
  public filters$: Observable<any>|undefined;
  public user$: Observable<any>|undefined;
  public season$: Observable<any>|undefined;
  public shareprofile$: Observable<any>|undefined;
  public mobileMenu$: Observable<any>|undefined;
  private destroy$ = new Subject();
  @ViewChild('music') myModal:ElementRef;
  showSwitch:boolean = false;
  showDropdown:boolean = false;
  playing:boolean = false;
  loaded:boolean = false;
  constructor(
    private renderer: Renderer2,
    public location: Location,
    @Inject(DOCUMENT) document,
    public router: Router,
    private activate: ActivatedRoute,
    private mainFacade:MainFacade
  ) {

  
    document.addEventListener("click", (ele):void => {
      console.log( (ele.target as Element).className.indexOf('ham'))
      if(ele?.target && (ele.target as Element).className && (ele.target as Element).className.indexOf('dd') < 0 ){
        this.showDropdown = false;
      }
      else if(ele?.target  && (ele.target as Element).className.indexOf('ham') < 0 ){
      
        this.mainFacade.getMobileMenu(false)
      }
      
    });


   
    
  }


  @HostListener("window:scroll", ["$event"])
  onWindowScroll(e) {
  
    if (window.pageYOffset > 100) {
      var element = document.getElementById("navbar-top");
      if (element) {
        element.classList.remove("navbar-transparent");
        element.classList.add("bg-primary");
        
      }
    } else {
      var element = document.getElementById("navbar-top");
      if (element && this.router.url !== '/game') {
        element.classList.add("navbar-transparent");
        element.classList.remove("bg-primary");
      }
    }
    
  }

  ngOnInit() {
    
    this.onWindowScroll(event);
    this.createSubscriptions();
  }

  ngAfterViewInit(): void {
    //this.myModal.nativeElement.play();
    //this.loaded=true;
  }

  pause(){
    this.myModal.nativeElement.muted = true;
    //this.myModal.nativeElement.play = false;
    this.playing = false;
  }

  play(){
    this.myModal.nativeElement.play();
    this.myModal.nativeElement.muted = false;
    //this.myModal.nativeElement.play = true;
    this.playing = true;
  }


  createSubscriptions(){
    this.user$ = this.mainFacade.user$;
    this.season$ = this.mainFacade.season$;
    this.shareprofile$ = this.mainFacade.shareprofile$;
    this.mobileMenu$ = this.mainFacade.mobileMenu$;
    //this.filters$ = this.mainFacade.filters$;
  }
  
  
}
